/**
 * Created by ModelParser
 * Date: 21-02-2022.
 * Time: 16:21.
 */
import {TherapistDefinition} from './definitions/TherapistDefinition';
import {HasAddress} from "@/interfaces/HasAddress";
import {HasPhone} from "@/interfaces/HasPhone";

export class Therapist extends TherapistDefinition implements
    HasAddress, HasPhone {

    constructor(json?: any) {
        super(json);
    }

    public get name(): string {
        return `${this.first_name} ${this.last_name}`;
    }

}
